import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';

import ReactGA from 'react-ga4';
import * as Sentry from '@sentry/browser';
import 'typeface-roboto';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { isProd } from './util/config';
import history from './util/history';
import { initFBEvents, initFBSdk } from './util/facebook-init';
import { initKlaviyo } from './util/klaviyo-init';
import './i18n';

if (isProd) {
  Sentry.init({
    dsn: 'https://2a4c2619fe7a4810af4cc011f486b49d@sentry.io/282776',
    captureUnhandledRejections: true,
  });
}

ReactGA.initialize(isProd ? 'G-PTH9LYX43V' : 'G-59QK6W53JZ');
history.listen((location) => {
  ReactGA.set({ page: location.pathname });
  ReactGA.send({
    hitType: 'pageview',
    page: location.pathname,
  });
});

ReactDOM.render(<App/>, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();

initFBEvents();
initKlaviyo();
initFBSdk();
